export default __webpack_public_path__ + "static/media/tick-green.bba99d20.svg";